import React, {memo} from 'react';
import {mobile} from 'shared/Breakpoints';
import styled from 'styled-components';

const TrademarkPoweredBy = () => {
    return (
        <Container>
            <Text>Powered By</Text>
            <Image
                src="/v2/dist-compat/header-images/header_logo_trademark.png"
                alt="Powered by Cabinetry.Online"
            />
        </Container>
    );
};

export default memo(TrademarkPoweredBy);

const Image = styled.img`
    width: 145px;
    margin-left: 8px; /* Space between text and image when in row layout */

    ${mobile`
        margin-left: 0;
        margin-top: 4px; /* Space between text and image when stacked */
    `}
`;

const Text = styled.div`
    color: ${({theme}) => theme.colors.primary.main};
    font-family: ${({theme}) => theme.typography.fontStyle.fontFamily};
    font-size: 0.85em;
`;

const Container = styled.div`
    display: flex;
    flex-direction: row; /* Default: inline */
    align-items: center;

    ${mobile`
        flex-direction: column; /* Stack vertically on small screens */
    `}
`;
